module.exports = __webpack_public_path__ + "img/footerBG.ff51f9ec.png";